import FooterMenu from "@desktop/components/Footer/FooterMenu";
// import { XMasDecoration } from "@shared/components";
import React from "react";
import { FormattedMessage } from "react-intl";

const Footer = () => (
  <footer className="footer">
    {/*<XMasDecoration*/}
    {/*  style={{*/}
    {/*    position: "absolute",*/}
    {/*    zIndex: 6,*/}
    {/*    top: 0,*/}
    {/*    left: 0,*/}
    {/*    width: "100%",*/}
    {/*    height: "3rem",*/}
    {/*    transform: "translateY(2.5rem)",*/}
    {/*  }}*/}
    {/*/>*/}
    <div className="footer__inner">
      <FooterMenu />
      <FormattedMessage id="boilerplate.components.Footer.Text">
        {(message) => <p>{message}</p>}
      </FormattedMessage>
      <FormattedMessage id="boilerplate.components.Footer.Copy">
        {(message) => <p>{message}</p>}
      </FormattedMessage>
    </div>
  </footer>
);

export default Footer;
